// ##############################
// // // Tasks for TasksCard - see Dashboard view
// #############################

const G = "G";
const P = "P";
const M = "M";
const XG = "XG";

var lockerColumns = [
  {
    label: "LK41 (11)",
    column: [G, P, P, M, P, P, P, P, P, M, M]
  }, 
  {
    label: "LK41 (9)",
    column: [G, P, P, M, P, P, P, M, XG]
  },
  {
    label: "LK400",
    column: [G, P, P, M, P, P, P, P, M, XG]
  }, 
  {
    label: "LK100",
    column: [G, M, P, P, P, P, G]
  }, 
  {
    label: "LK200",
    column: [G, P, M, P, P, P, P, G]
  }, 
  {
    label: "LK200 RN",
    column: [P, P, M, P, M, M, G]
  }, 

];




module.exports = {
  // these 3 are used to create the tasks lists in TasksCard - Dashboard view
  lockerColumns
};
